// reactstrap components
import { Container, Col, Row, Button } from "reactstrap";

import React from "react";
import ParticleBackground from "components/Particles";

const UK_PRIMARY = "#3e3f99";
const UK_SECONDARY = "#00a8c4";

function LandingPageHeader({ home }) {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (document.documentElement.scrollTop > 50 || document.body.scrollTop > 50) {
      } else if (document.documentElement.scrollTop < 300 || document.body.scrollTop < 300) {
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  return (
    <div>
      <div
        style={{
          background: `url(${require(`assets/images/${size ? "BG1.png" : "background2.jpg"}`)})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: size ? "100%" : "cover",
          backgroundAttachment: size ? "fixed" : "scroll",
          backgroundSize: "cover",
          paddingTop: "8rem",
          overflow: "hidden",
        }}
        className="page-header"
      >
        <Container style={{ marginTop: !size && "-1rem" }}>
          <Row className="justify-content-center">
            <Col md={6} xs={12}>
              <img
                src={require(`assets/images/logo/DTUK-26-LOGO.png`)}
                style={{ maxWidth: size ? "450px" : "300px" }}
                width="100%"
                alt="UK Digital Twin 2026"
              />

              <h1
                className="text-700 mt-3 mb-0"
                style={{
                  fontSize: size ? "1.5rem" : "1.05rem",
                  color: UK_PRIMARY,
                  letterSpacing: "0.02em",
                }}
              >
                MILLENNIUM POINT, BIRMINGHAM, UK
              </h1>

              <div className="d-flex mt-4" style={{ gap: size ? "1.75rem" : "1.25rem", flexWrap: "wrap" }}>
                <div>
                  <div style={{ backgroundColor: UK_PRIMARY, padding: "2px 8px" }}>
                    <h1
                      className="text-700 text-white m-0"
                      style={{
                        fontSize: size ? "1.15rem" : "0.95rem",
                        letterSpacing: "0.04em",
                      }}
                    >
                      WORKSHOPS
                    </h1>
                  </div>
                  <div style={{ display: "flex", marginTop: "0.35rem" }}>
                    <h1
                      className="text-700 m-0 border-right pr-2"
                      style={{
                        fontSize: size ? "3rem" : "2.4rem",
                        lineHeight: 1,
                        color: UK_PRIMARY,
                        borderColor: `${UK_PRIMARY}55`,
                      }}
                    >
                      10
                    </h1>
                    <h1
                      className="text-700 m-0 pl-2 align-self-center"
                      style={{
                        fontSize: size ? "1rem" : "0.85rem",
                        lineHeight: 1.25,
                        color: UK_PRIMARY,
                      }}
                    >
                      NOVEMBER
                      <br />
                      2026
                    </h1>
                  </div>
                </div>

                <div>
                  <div style={{ backgroundColor: UK_SECONDARY, padding: "2px 8px" }}>
                    <h1
                      className="text-700 text-white m-0"
                      style={{
                        fontSize: size ? "1.15rem" : "0.95rem",
                        letterSpacing: "0.04em",
                      }}
                    >
                      CONFERENCE
                    </h1>
                  </div>
                  <div style={{ display: "flex", marginTop: "0.35rem" }}>
                    <h1
                      className="text-700 m-0 border-right pr-2"
                      style={{
                        fontSize: size ? "3rem" : "2.4rem",
                        lineHeight: 1,
                        color: UK_PRIMARY,
                        borderColor: `${UK_PRIMARY}55`,
                      }}
                    >
                      11
                    </h1>
                    <h1
                      className="text-700 m-0 pl-2 align-self-center"
                      style={{
                        fontSize: size ? "1rem" : "0.85rem",
                        lineHeight: 1.25,
                        color: UK_PRIMARY,
                      }}
                    >
                      NOVEMBER
                      <br />
                      2026
                    </h1>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <h5
                  className="text-700 mb-2"
                  style={{
                    fontSize: size ? "0.75rem" : "0.65rem",
                    letterSpacing: "0.12em",
                    color: "#5a6280",
                  }}
                >
                  SUPPORTED BY
                </h5>
                <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                  <img
                    src={require(`assets/images/logo/db.png`)}
                    style={{ maxWidth: size ? "180px" : 130, height: "auto" }}
                    width="100%"
                    alt="Digital Birmingham"
                  />
                  <div
                    style={{
                      width: "1px",
                      alignSelf: "stretch",
                      minHeight: size ? "48px" : "36px",
                      background: "rgba(62,63,153,0.25)",
                    }}
                  />
                  <img
                    src={require(`assets/images/logo/bcc.png`)}
                    style={{ maxWidth: size ? "180px" : 130, height: "auto" }}
                    width="100%"
                    alt="Birmingham City Council"
                  />
                </div>
              </div>

              <div className="mt-4">
                <Button
                  href="/register"
                  className="rounded-0 navbar-item-custom text-400 text-white px-4"
                  color="primary"
                  size="lg"
                  target="_blank"
                  style={{ background: UK_PRIMARY, marginRight: "0.5rem", marginBottom: "0.5rem" }}
                  rel="noopener noreferrer"
                >
                  <span
                    style={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: size ? "20px" : "16px",
                      fontWeight: 700,
                    }}
                  >
                    REGISTER NOW
                  </span>
                </Button>
                <Button
                  href="/agenda"
                  className="rounded-0 navbar-item-custom text-400 text-white px-4"
                  color="primary"
                  size="lg"
                  target="_blank"
                  style={{ background: UK_SECONDARY, marginBottom: "0.5rem" }}
                  rel="noopener noreferrer"
                >
                  <span
                    style={{
                      color: "#fff",
                      textTransform: "none",
                      fontSize: size ? "20px" : "16px",
                      fontWeight: 700,
                    }}
                  >
                    VIEW AGENDA
                  </span>
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <ParticleBackground />
      </div>
    </div>
  );
}

export default LandingPageHeader;
